import React from "react";
import MileStoneForm from "../components/forms/MileStoneForm" 

const ProjectInformation: React.FC = () => {
  return (
   <>
   <MileStoneForm />
   </>
  );
};

export default ProjectInformation;
